import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-companies',
    templateUrl: './companies.component.html',
    styleUrls: ['./companies.component.css']
})
export class CompaniesComponent implements OnInit {
    public name: string = '';

    constructor() {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/app/companies/companies.component.ts